// import React from 'react'
// import { Link } from 'react-router-dom'

// function Footer() {
//     return (
//         <>
//             <footer className='bg-[#001E42] relative lg:pb-[120px] pb-[40px] lg:pt-[100px] pt-[50px] lg:px-[60px] px-[20px]'>
//                 {/* <div className="max-w-[1240px] w-[90%] lg:w-full absolute left-[50%] translate-x-[-50%] top-[-100px] lg:top-[-146px] bg-[#FFFFFF] rounded-[20px] lg:rounded-[30px] py-[30px] lg:py-[53px] px-[20px] lg:px-0"
//                     style={{ boxShadow: "0px 10px 100px 0px #89A1A82B" }}>
//                     <h6 className="pb-[15px] lg:pb-[21px] font-neue font-[400] text-[22px] sm:text-[28px] lg:text-[36px] leading-[32px] sm:leading-[40px] lg:leading-[52px] text-center text-[#0F3460]">
//                         DOT Weekly Subscription: <span className="text-[#BB872A]">Stay Attuned</span>
//                     </h6>
//                     <p className="text-center font-[400] font-instrument text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] lg:leading-[30px] tracking-[-0.22px] text-[#05003E] pb-[20px] lg:pb-[31px]">
//                         Join the quiet list — a weekly signal from the corridor.
//                     </p>
//                     <div className="max-w-[532px] w-full mx-auto flex flex-col lg:flex-row gap-[15px] lg:gap-0 justify-between items-center pb-[10px] border-b border-[#2E4D7380]">
//                         <div className="flex gap-[10px] items-center w-full lg:w-auto">
//                             <img src="/assets/home/mail.svg" alt="mail" className="w-[18px] h-[18px] lg:w-auto lg:h-auto" />
//                             <input
//                                 type="text"
//                                 className="flex-1 font-[400] font-instrument text-[14px] sm:text-[15px] lg:text-[16px] text-[#0F3460] border-none outline-none p-0"
//                                 placeholder="Your Email Address"
//                             />
//                         </div>
//                         <button
//                             style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
//                             className="w-full lg:w-auto py-[10px] lg:py-[12px] px-[15px] transition-all duration-500 hover:bg-transparent hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[10px] lg:rounded-[12px] font-[400] font-instrument text-[13px] sm:text-[14px] leading-[20px] text-center text-[#FFFFFF]"
//                         >
//                             Subscribe to DOT Weekly
//                         </button>
//                     </div>
//                 </div> */}
//                 <div className="max-w-[1440px] w-full mx-auto flex flex-col lg:flex-row lg:gap-[250px] gap-[30px] px-[20px] lg:px-0 justify-between">
//                     <div className="max-w-[300px] w-full">
//                         <Link to="/">
//                             <img src="/assets/nav/f-logo.svg" alt="logo" className="w-[140px] sm:w-[160px] lg:w-auto" />
//                         </Link>
//                         <h6 className="font-[500] font-Merriweather text-[16px] sm:text-[16px] lg:text-[18px] leading-[28px] sm:leading-[30px] lg:leading-[32px] text-[#FFFFFF] py-[20px] lg:py-[30px]">
//                        We build quietly. We respond selectively. Alignment is the only pitch that matters.
//                         </h6>
//                         <div className="flex gap-[15px] sm:gap-[20px] lg:gap-[25px] flex-wrap text-[#FFFFFF] text-[20px] ">
//                         <i class="bi bi-twitter"></i>
//                         <i class="bi bi-linkedin"></i>
//                             {/* <Link><img src="/assets/footer/icon1.svg" alt="" className="w-[28px] sm:w-[32px]" /></Link>
//                             <Link><img src="/assets/footer/icon2.svg" alt="" className="w-[28px] sm:w-[32px]" /></Link>
//                             <Link><img src="/assets/footer/icon3.svg" alt="" className="w-[28px] sm:w-[32px]" /></Link>
//                             <Link><img src="/assets/footer/icon4.svg" alt="" className="w-[28px] sm:w-[32px]" /></Link> */}
//                         </div>
//                     </div>
//                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-[30px] sm:gap-[35px] lg:gap-[40px] flex-1">
//                         <div>
//                             <h6 className="font-[500] font-Merriweather text-[20px] sm:text-[22px] lg:text-[24px] leading-[28px] sm:leading-[30px] lg:leading-[32px] text-[#FFFFFF] pb-[20px] lg:pb-[30px]">
//                                 Quick links
//                             </h6>
//                             <div className="flex flex-col gap-[12px] sm:gap-[14px] lg:gap-[16px]">
//                                 <Link className="font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] leading-[22px] sm:leading-[24px] lg:leading-[25px] text-[#FFFFFFB2]">About me</Link>
//                                 <Link className="font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] leading-[22px] sm:leading-[24px] lg:leading-[25px] text-[#FFFFFFB2]">What We Do</Link>
//                                 <Link className="font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] leading-[22px] sm:leading-[24px] lg:leading-[25px] text-[#FFFFFFB2]">The Corridor</Link>
//                                 <Link className="font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] leading-[22px] sm:leading-[24px] lg:leading-[25px] text-[#FFFFFFB2]">Our Network</Link>
//                                 <Link className="font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] leading-[22px] sm:leading-[24px] lg:leading-[25px] text-[#FFFFFFB2]">Signal Alignment</Link>
//                             </div>
//                         </div>
//                         {/* <div>
//                             <h6 className="font-[500] font-dm text-[20px] sm:text-[22px] lg:text-[24px] leading-[28px] sm:leading-[30px] lg:leading-[32px] text-[#FFFFFF] pb-[20px] lg:pb-[30px]">
//                                 Categories
//                             </h6>
//                             <div className="flex flex-col gap-[12px] sm:gap-[14px] lg:gap-[16px]">
//                                 <Link className="font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] text-[#FFFFFFB2]">Business Updates</Link>
//                                 <Link className="font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] text-[#FFFFFFB2]">Government Updates</Link>
//                                 <Link className="font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] text-[#FFFFFFB2]">Newsletter</Link>
//                                 <Link className="font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] text-[#FFFFFFB2]">Reports</Link>
//                                 <Link className="font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] text-[#FFFFFFB2]">Research</Link>
//                             </div>
//                         </div> */}
//                         <div>
//                             <h6 className="font-[500] font-Merriweather text-[20px] sm:text-[22px] lg:text-[24px] text-[#FFFFFF] pb-[20px] lg:pb-[30px]">
//                                 Contact
//                             </h6>
//                             <div className="flex flex-col gap-[12px] sm:gap-[14px] lg:gap-[16px]">
//                                 <Link className="font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] text-[#FFFFFFB2]">contact@folxo.com</Link>
//                                 {/* <Link className="font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] text-[#FFFFFFB2]">(316) 555-0116</Link> */}
//                                 <Link className="font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] text-[#FFFFFFB2]">1500 K Street, 2nd Floor
// Washington, DC 20005, USA</Link>
//                             </div>
//                         </div>
//                     </div>
//                     {/* <div className="max-w-[330px] w-full">
//                         <h6 className="font-[500] font-dm text-[20px] sm:text-[22px] lg:text-[24px] text-[#FFFFFF] pb-[20px] lg:pb-[30px]">
//                             Newsletter
//                         </h6>
//                         <p className="font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] leading-[24px] sm:leading-[26px] lg:leading-[25px] text-[#FFFFFFB2] pb-[15px] lg:pb-[18px]">
//                             Subscribe my newsletter and get all the latest information
//                         </p>
//                         <div className="flex flex-col sm:flex-row justify-between items-center gap-[10px] sm:gap-[14px] bg-[#FFFFFF33] rounded-[30px] py-[7px] px-[12px] sm:pl-[18px] sm:pr-[7px]">
//                             <input
//                                 type="text"
//                                 className="p-0 bg-transparent border-none font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] text-[#FFFFFFB2] w-full sm:max-w-[171px]"
//                                 placeholder="Enter your email..."
//                             />
//                             <button className="bg-[#BB872A] rounded-[30px] py-[8px] sm:py-[10px] px-[16px] sm:px-[20px] font-[400] font-neue text-[14px] sm:text-[15px] lg:text-[16px] leading-[22px] sm:leading-[26px] lg:leading-[28px] text-center text-[#FFFFFF] w-full sm:w-auto">
//                                 Subscribe
//                             </button>
//                         </div>
//                     </div> */}
//                 </div>
//             </footer>
//             <div className='bg-[#BB872A] py-[18px] font-neue font-[400] text-[18px] leading-[28px] text-center text-[#FFFFFF]'>
//               2025 @ IndUS Tech . All Right Reserved
//             </div>
//         </>
//     )
// }

// export default Footer

import Aos from 'aos';
import React, { useEffect } from 'react'
import { BiCopyright } from 'react-icons/bi';
import { FaLinkedinIn, FaXTwitter } from 'react-icons/fa6';
import { Link } from 'react-router-dom'

function Footer() {

  useEffect(() => {
    Aos.init({ once: true });
  }, []);
  return (
    <>
<footer className="bg-[#001E42] relative lg:pb-[120px] pb-[40px] lg:pt-[100px] pt-[50px] overflow-hidden">
  <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[70px]">

    {/* MAIN GRID */}
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-[40px]">

      {/* LOGO */}
      <div
        data-aos="fade-right"
        data-aos-delay="200"
        className="flex flex-col items-start lg:pl-[10px]"
      >
        <Link to="/">
          <img
            src="/assets/logos/PNG White.png"
            alt="logo"
            className="w-[180px]"
          />
        </Link>
      </div>

      {/* QUICK LINKS */}
      <div
        data-aos="fade-up"
        data-aos-delay="300"
        className="lg:pl-[10px]"
      >
        <h6 className="font-[500] font-Merriweather text-[20px] lg:text-[24px] text-[#FFFFFF] pb-[20px]">
          Quick Links
        </h6>
        <div className="flex flex-col gap-[14px]">
          <Link to="/" className="font-neue text-[#FFFFFFB2]">Home</Link>
          <Link to="/what-we-do" className="font-neue text-[#FFFFFFB2]">What We Do</Link>
          <Link to="/Insights" className="font-neue text-[#FFFFFFB2]">Insights</Link>
          {/* <Link to="/our-network" className="font-neue text-[#FFFFFFB2]">Our Network</Link> */}
        </div>
      </div>

      {/* IMPORTANT LINKS */}
      <div
        data-aos="fade-up"
        data-aos-delay="400"
        className="lg:pl-[10px]"
      >
        <h6 className="font-[500] font-Merriweather text-[20px] lg:text-[24px] text-[#FFFFFF] pb-[20px]">
          Important Links
        </h6>
        <div className="flex flex-col gap-[14px]">
          <Link to="/contact-us" className="font-neue text-[#FFFFFFB2]">Contact</Link>
          <Link to="/privacy-policy" className="font-neue text-[#FFFFFFB2]">Privacy Policy</Link>
          <Link to="/terms-condition" className="font-neue text-[#FFFFFFB2]">Terms & Conditions</Link>
        </div>
      </div>

      {/* CONTACT US */}
      <div
        data-aos="fade-left"
        data-aos-delay="500"
        className="lg:pl-[10px]"
      >
        <h6 className="font-[500] font-Merriweather text-[20px] lg:text-[24px] text-[#FFFFFF] pb-[20px]">
          Contact
        </h6>
        <div className="flex flex-col gap-[14px]">
          <span className="font-neue text-[#FFFFFFB2]">
            info@industechcenter.org
          </span>
          <span className="font-neue text-[#FFFFFFB2] max-w-[260px]">
            1500 K Street, Suite 200 Washington DC 20005 USA
          </span>

          <div className="flex gap-[18px] pt-[10px]">
            <Link
              to="https://x.com/TheIndUSTech"
              className="text-white text-[18px] hover:text-[#BB872A] transition"
            >
              <FaXTwitter />
            </Link>
            <Link
              to="https://www.linkedin.com/company/theindustech/"
              className="text-white text-[18px] hover:text-[#BB872A] transition"
            >
              <FaLinkedinIn />
            </Link>
          </div>
        </div>
      </div>

    </div>
  </div>
</footer>




      <div
        className='bg-[#BB872A] py-[18px] font-neue font-[400] text-[16px] sm:text-[18px] leading-[26px] sm:leading-[28px] text-center text-[#FFFFFF] flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-1'
      >
        <BiCopyright/>  <span>  2026 IndUS Tech JGJ Ventures LLC. All rights reserved.</span>
      </div>

    </>
  )
}


export default Footer

